import { RecurringOrdersState, RecurringOrderTabs } from './types';

const defaultState: RecurringOrdersState = {
  isStandingOrderSelected: true,
  standingOrders: null,
  sweepOrders: null,
  isLoadingStandingOrders: false,
  isLoadingSweepOrders: false,
  standingOrdersError: undefined,
  sweepOrdersError: undefined,
  selectedRecurringOrdersTab: RecurringOrderTabs.standing,
  recurringOrderAction: null,
  selectedRecurringOrder: null,
  isLoadingCancelRecurringOrder: false,
  cancelRecurringOrderError: undefined,
  isLoadingViewDetailsRecurringOrder: false,
  viewDetailsRecurringOrderError: undefined,
  cancelRecurringOrderData: null,
  viewRecurringOrderDetailsData: null,
  recurringOrderSubmitAction: null,
  onRecurringOrderAction: () => {},
  onSelectRecurringOrdersTab: () => {},
  onResetSelectedRecurringOrder: () => {},
  onRecurringOrderSubmitAction: () => {},
  onDownloadOption: () => {},
};

export { defaultState };
